var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKreneBigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 100,
    viewBox: "0 0 377 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5901_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0728 71.272L28.5661 69.143L29.3074 100L30.0728 71.272Z",
    fill: "#887B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9717 0L30.517 31.245L31.1661 30.2393L31.9717 0Z",
    fill: "#887B8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.438 59.2042L271.76 100L305.064 93.3333L313.057 0H279.753L276.076 53.1347L259.77 0H229.131L226.466 100H257.106L258.438 59.2042ZM46.6254 100L79.9293 93.3333L47.9576 50L85.2579 0H53.2862L31.1661 30.2393L30.517 31.245L31.9717 0H2.66431L0 100H29.3074L28.5661 69.143L30.0728 71.272L46.6254 100Z",
    fill: "#887B8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.407 49.8709C154.148 52.1563 152.522 54.2682 150.528 56.2086C148.533 58.149 146.127 60.0033 143.308 61.7702L159.859 93.3333L126.555 100L112.216 67.6667L111.235 100H81.9276L84.5919 6.28079C98.9125 0.999999 108.238 1.25528e-09 120.672 0C133.106 -1.25528e-09 143.72 6.15232 147.276 8.86821C150.831 11.5841 153.683 14.9695 155.83 19.0219C157.976 23.0748 159.049 27.796 159.049 33.1848C159.049 36.5483 158.757 39.5987 158.171 42.3364C157.586 45.0748 156.664 47.5861 155.407 49.8709ZM126.949 26.3623C127.925 27.4616 128.662 28.7662 129.16 30.2748C129.659 31.7848 129.908 33.4437 129.908 35.2543C129.908 37.4113 129.421 39.2642 128.445 40.8166C127.469 42.3689 126.211 43.6411 124.672 44.6324C123.132 45.6245 121.397 46.357 119.468 46.8311C117.539 47.306 115.641 47.5424 113.777 47.5424H112.216L113.257 23.4841C114.037 23.2689 114.839 23.1073 115.663 22.9993C116.486 22.8921 117.332 22.8371 118.2 22.8371C120.152 22.8371 121.853 23.1503 123.306 23.7748C124.759 24.4007 125.973 25.2623 126.949 26.3623Z",
    fill: "#887B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.802 25.3333H195.827L195.161 36.6667H214.477L213.145 56.6667H193.829L193.163 70H220.714L219.14 100H162.523L165.187 0H226.466L223.802 25.3333Z",
    fill: "#887B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.336 25.3333H346.36L345.694 36.6667H365.011L363.678 56.6667H344.362L343.696 70H371.247L369.673 100H313.057L315.721 0H377L374.336 25.3333Z",
    fill: "#887B8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5901_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreneBigLogo);
export default __webpack_public_path__ + "static/media/KreneBigLogo.3ef8fab9eee0f76db50c3c01e0f65380.svg";
export { ForwardRef as ReactComponent };